import { connect } from 'react-redux';

import { toastr } from 'react-redux-toastr';
import Actions from '../actions';
import ProductTile from '../components/product-tile';
import { addProductToCartNextActionEP, addProductToCartNotifyEP } from '../errors/processors/add-product-to-cart';
import refreshOrderProcess from '../services/refresh-order-process';
import translations from '../../translations/app-translations.json';

const mapStateToProps = (state, ownProps) => ({
    locale: state.locale,
    user: state.user,
    access_token: state.auth.access_token,
    order: state.order,
    currentStore: state.stores.currentStore,
    currentZone: state.zones.currentZone,
});

const mapDispatchToProps = (dispatch) => ({
    addProductToCart: (variantId, quantity = 1, zoneId, locale, userToken, order, extraData = null) => {
        dispatch(Actions.addingProductToCart());
        dispatch(Actions.addProductToCart(variantId, quantity, zoneId, locale, userToken, extraData))
            .then(() => {
                refreshOrderProcess(dispatch, locale, toastr, {
                    addingProductToCartAction: true,
                    successNotify: `${translations[locale]['item-added']}. ${translations[locale]['proceed-to-checkout']}.`,
                });
            })
            .catch((error) => {
                addProductToCartNotifyEP(locale, error, toastr);
                addProductToCartNextActionEP(dispatch, order, locale, userToken);
            });
    },
    emptyCart: (order, locale) => dispatch(Actions.emptyCart(order, locale)),
});

const ProductTileConnector = connect(mapStateToProps, mapDispatchToProps)(ProductTile);

export default ProductTileConnector;



/** WEBPACK FOOTER **
 ** ./src/containers/product-tile-connector.js
 **/